var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_2173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.204 118.564C175.65 118.564 197.9 96.3141 197.9 68.8678C197.9 41.4216 175.65 19.1719 148.204 19.1719C120.757 19.1719 98.5078 41.4216 98.5078 68.8678C98.5078 96.3141 120.757 118.564 148.204 118.564Z",
    fill: "#9747FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.037 30.6769V92.03H7.66913V30.6769H115.037ZM122.706 23.0078H0V99.6991H122.706V23.0078Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3525 46.0148C67.5875 46.0148 72.8562 53.0398 72.8562 61.3531C72.8562 69.6664 67.5875 76.6914 61.3525 76.6914C55.1175 76.6914 49.8488 69.6664 49.8488 61.3531C49.8488 53.0398 55.1175 46.0148 61.3525 46.0148ZM61.3525 38.3457C50.7653 38.3457 42.1797 48.6492 42.1797 61.3531C42.1797 74.057 50.7653 84.3605 61.3525 84.3605C71.9436 84.3605 80.5253 74.057 80.5253 61.3531C80.5253 48.6492 71.9436 38.3457 61.3525 38.3457Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_2173"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122.706,
    height: 122.706,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/bill.f56209dfc0c3ab8b270c1cdf6e4cb835.svg";
export { ForwardRef as ReactComponent };